export const MYSIDEWALK_LOGO_MARK_SVG = 'https://res.cloudinary.com/mindmixerprod/image/upload/v1613153802/application/mySW_logo-icon_new2021.svg';
export const MYSIDEWALK_LOGO_TYPE_SVG = 'https://res.cloudinary.com/mindmixerprod/image/upload/v1612898894/application/mySW-logo_white_new2021.svg';
